//
// RuntimeConfiguration.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseModel";
import "./RuntimeScheme";
import "./PlatformImplementationFactory";

var RuntimeConfiguration = createModule("commons_RuntimeConfiguration", [130,13,144], EventDispatcher, [
    ,
    {
        implementationFactory: 1,
        logConfig: 7,
        scheme: 4,
        pathToFontManifestFile: 7,
        enableTextureCaching: 2,
        enableTraceLogging: 2,
        locale: 7,
        defaultImageDataPolicies: 3,
        pathToInstallDirectory: 7,
        pathToFontDirectory: 7,
        supportsMSAA: 2,
        logLevel: 7,
        enableSystemFontLookups: 2,
        hasRunLoop: 2,
        requiresCoInitialize: 2,
        formatterLocale: 7,
        logFilePath: 7,
        pathToWorkingDirectory: 7,
        dpi: 5,
        supportsThreads: 2,
        pathToResourceDirectory: 7,
        supportsAsyncNetworking: 2,
        needsProxy: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default RuntimeConfiguration;
